import { cn } from '@/lib/utils';

function getPasswordScore(password: string): number {
  if (!password) return 0;
  let score = 0;
  if (password.length >= 8) score = 1;
  if (score >= 1 && /[a-z]/.test(password) && /[A-Z]/.test(password)) score = 2;
  if (score >= 2 && /\d/.test(password)) score = 3;
  if (score >= 3 && (/[^a-zA-Z0-9]/.test(password) || password.length >= 12)) score = 4;
  return score;
}

const BAR_COLORS = [
  'bg-blue-500',
  'bg-green-500',
  'bg-orange-400',
  'bg-red-500',
];

interface PasswordStrengthProps {
  password: string;
}

export function PasswordStrength({ password }: PasswordStrengthProps) {
  const score = getPasswordScore(password);

  return (
    <div className="flex items-center gap-3">
      <span className="text-xs text-muted-foreground">Kekuatan</span>
      <div className="flex flex-1 gap-1">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className={cn(
              'h-1.5 flex-1 rounded-full',
              i < score ? BAR_COLORS[i] : 'bg-gc-300'
            )}
          />
        ))}
      </div>
    </div>
  );
}
